import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SessionGuard} from "../../session/session.guard";
import {FestivoComponent} from "./festivo/festivo.component";

const routes: Routes = [
    {
        path: 'festivos',
        component: FestivoComponent,
        canActivate: [SessionGuard],
        data: {title: "Festivos"}
    },
    {
        path: "",
        redirectTo: "inicio",
        pathMatch: "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LocalizacionRoutingModule {
}
